/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import ReactLoading from 'react-loading';

import Txt from '../atoms/Txt';
import Row from '../atoms/FlexRow';
import theme from '../../constants/AppTheme';
import VerSpacer from '../atoms/VerSpacer';
import HorSpacer from '../atoms/HorSpacer';
import InputData from '../molecules/InputData';
import { fireAuth, fireStore } from '../../database/utils/firebase';
import { updateSelfUser } from '../../database/repositories/UserRepository';
import Address from '../molecules/Address';
import NewAddress from '../molecules/NewAddress';
import { hasProps } from '../../utils/util';
import { CreditCard } from '../molecules/CreditCard';
import CreateCreditCard from '../molecules/CreateCreditCard';

const Body = styled.div`
  padding: 10px;
  display: flex;
  flex: 1;
  flex-direction: column;

  label {
    padding: 0;
    margin: 0;
  }

  label:hover {
    cursor: pointer;
  }
`;

const Section = styled.div`
  background-color: ${({ color }) => color || theme.lightGray};
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  flex: 1;

  @media (max-width: 768px) {
    width: 400px;
  }
`;

const HorLine = styled.div`
  border-top: 1px solid ${theme.black};
  padding: 0;
  margin: 5px 0;
  width: 100%;
`;

const ButtonView = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Button = styled.button`
  border: none;
  margin-top: 10px;
  border-radius: 10px;
  background-color: ${theme.red};
  padding: 5px 15px;
  width: 50%;
`;

function UserDataTab({ tabId, data, style, ...props }) {
  const userData = useSelector((state) => state.auth.user_data);

  const [loading, setLoading] = useState();
  const [, setErrorMessage] = useState();

  const [username, setUsername] = useState();
  const [email, setEmail] = useState();
  const [fullName, setFullName] = useState();
  const [identifier, setIdentifier] = useState();
  const [phone, setPhone] = useState();
  const [phoneAlternative, setPhoneAlternative] = useState();
  const [addresses, setAddresses] = useState([]);

  const [showNewAddressModal, setShowNewAddressModal] = useState(false);
  const [showCreditCardModal, setCreditCardModal] = useState(false);
  const [newAddress, setNewAddress] = useState();
  const [creditCards, setCreditCards] = useState([]);
  const [loadingCreditCard, setLoadingCreditCard] = useState(true);

  useEffect(() => {
    if (!userData) return;
    // TODO: username está faltando no cadastro, modificar aqui depois que adicionar
    setUsername(userData?.username ?? userData?.name);
    setEmail(fireAuth.currentUser?.email);
    setFullName(userData?.name);
    setIdentifier(userData?.cpf);
    setPhone(userData?.phone);
    setPhoneAlternative(userData?.phoneAlternative);
    setAddresses(userData?.addresses ?? []);
    setTimeout(() => {
      setLoadingCreditCard(false);
      //   setCreditCards(fakeCards);
    }, 4000);
    // eslint-disable-next-line no-use-before-define
    loadCards();
  }, [userData, fireAuth.currentUser]);

  const loadCards = async () => {
    const user = fireAuth.currentUser;
    if (user?.uid) {
      fireStore
        .collection('usuarios')
        .doc(user?.uid)
        .collection('creditCards')
        .get()
        .then((res) => {
          const tempCards = [];
          res.docs.forEach((card) => {
            tempCards.push(card.data());
          });
          setCreditCards(tempCards);
        })
        .catch((err) => console.log(err));
    }
  };

  const updateData = async () => {
    setLoading(true);
    const newData = { addresses };

    const checkAndAdd = (key, currentValue, compareValue = null) => {
      if ((compareValue || userData[key]) !== currentValue) {
        newData[key] = currentValue;
      }
    };

    checkAndAdd('username', username);
    checkAndAdd('name', fullName);
    checkAndAdd('cpf', identifier);
    checkAndAdd('phone', phone);
    checkAndAdd('phoneAlternative', phoneAlternative);

    if (fireAuth.currentUser?.email !== email) {
      // TODO: atualizar email no firebase auth também.
      newData.email = email;
    }
    try {
      await updateSelfUser(newData);
    } catch (error) {
      console.error(error);
      setErrorMessage('Erro ao tentar salvar novos dados.');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteCreditCard = (id) => {
    const user = fireAuth.currentUser;
    console.log(id);
    if (user?.uid && id) {
      fireStore
        .collection('usuarios')
        .doc(user?.uid)
        .collection('creditCards')
        .doc(id)
        .delete()
        .finally(loadCards);
    }
  };

  if (data) {
    return (
      <Body id={tabId} style={style} {...props}>
        <VerSpacer size={20} />
        <Txt color={theme.blue} size="20px" p>
          DADOS DA CONTA
        </Txt>
        <VerSpacer />
        <Section>
          <InputData text="Usuário" value={username} onEdit={setUsername} />
          <HorLine />
          <InputData text="E-mail" value={email} onEdit={setEmail} />
        </Section>
        <VerSpacer />
        <Section color={theme.softBlue}>
          <Row justify="flex-start">
            <i
              className="fas fa-exclamation-triangle"
              style={{
                color: theme.red,
                fontSize: 28
              }}
            />
            <HorSpacer />
            <Txt p debug>
              Você não está recebendo a Nota Fiscal eletrônica
            </Txt>
            <div style={{ flex: 1 }} />
            <div>
              <Txt color={theme.red} size="18px">
                Receber
              </Txt>
            </div>
          </Row>
        </Section>
        <VerSpacer size={25} />
        <Txt color={theme.blue} size="20px" p>
          DADOS PESSOAIS
        </Txt>
        <VerSpacer />
        <Section>
          <InputData text="Nome Completo" value={fullName} onEdit={setFullName} />
          <HorLine />
          <InputData text="Documento" value={identifier} onEdit={setIdentifier} />
          <HorLine />
          <InputData text="Telefone" value={phone} onEdit={setPhone} />
          <HorLine />
          <InputData
            text="Telefone Alternativo"
            value={phoneAlternative}
            onEdit={setPhoneAlternative}
          />
        </Section>
        <VerSpacer size={25} />
        <Txt color={theme.blue} size="20px" p>
          CARTÕES DE CRÉDITO
        </Txt>
        <VerSpacer />
        <Section>
          {showCreditCardModal ? (
            <CreateCreditCard onClose={() => setCreditCardModal(false)} />
          ) : (
            <Txt
              color={theme.red}
              style={{ cursor: 'pointer' }}
              onClick={() => setCreditCardModal(true)}>
              Adicionar cartão de crédito
            </Txt>
          )}
          {loadingCreditCard ? (
            <Center>
              <ReactLoading type="spinningBubbles" color="#002666" height={60} width={59} />
            </Center>
          ) : creditCards.length === 0 ? (
            <Center>
              <Txt>Nenhum cartão de crédito cadastrado.</Txt>
            </Center>
          ) : (
            creditCards.map((creditCard) => (
              <>
                <CreditCard
                  key={creditCard.creditCardId}
                  {...creditCard}
                  onDelete={() => handleDeleteCreditCard(creditCard.creditCardId)}
                />
                <VerSpacer size={10} />
              </>
            ))
          )}
        </Section>
        <VerSpacer size={25} />
        <Txt color={theme.blue} size="20px" p>
          ENDEREÇOS
        </Txt>
        <VerSpacer />
        <Section>
          {addresses.map((address, index) => (
            <Address
              address={address}
              key={index}
              onChange={(editedAddress) => {
                if (addresses[index]) {
                  const newAddresses = new Array(addresses);
                  newAddresses[index] = editedAddress;
                  setAddresses(newAddresses);
                }
              }}
            />
          ))}
          {showNewAddressModal ? (
            <>
              <NewAddress onNewAddress={setNewAddress} />
              <Txt
                color={theme.red}
                onClick={() => {
                  const requiredProps = ['address', 'district', 'city', 'state', 'zip'];
                  if (!hasProps(newAddress, ...requiredProps)) return;
                  setAddresses(addresses.concat(newAddress));
                  setShowNewAddressModal(false);
                }}>
                Adicionar
              </Txt>
              <Txt
                color={theme.red}
                onClick={() => {
                  setShowNewAddressModal(false);
                }}>
                Cancelar
              </Txt>
            </>
          ) : (
            <Txt color={theme.red} onClick={() => setShowNewAddressModal(true)}>
              Adicionar endereço
            </Txt>
          )}
        </Section>
        <ButtonView>
          <Button onClick={() => !loading && updateData()}>
            <Txt color="white">{loading ? 'Salvando...' : 'Salvar'}</Txt>
          </Button>
        </ButtonView>
      </Body>
    );
  }

  return null;
}

const Center = styled.div`
  align-self: center;
  margin: 50px;
`;

export default UserDataTab;
